import { datadogRum } from '@datadog/browser-rum';

const runDatadog = () => {
  datadogRum.init({
    applicationId: 'e143be5a-ee9c-4213-8b6b-91a1729e38d0',
    clientToken: 'pubdd234bfd71706379556819336c89b34e',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'ims',
    env: 'prod',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    allowedTracingUrls: [
      'https://api.alpinehomeair.com',
      'https://partnernet.alpinehomeair.com',
      'https://imsapi.alpinehomeair.com'
    ],
    trackResources: true,
    trackLongTasks: true,
    trackSessionAcrossSubdomains: true,
    defaultPrivacyLevel: 'allow',
    beforeSend: (event) => {
      // CSP violations surface as *error* events with source 'report' (not
      // resource events — the old `resource.type === 'csp'` check never
      // matched anything). Drop report-only violations (Cloudflare Page
      // Shield monitoring noise, nothing actually blocked); keep
      // disposition 'enforce' — real blocks.
      if (
        event.type === 'error' &&
        event.error?.source === 'report' &&
        event.error?.csp?.disposition === 'report'
      ) {
        return false;
      }
      return true;
    }
  });
};
export default runDatadog;
